module.exports = __webpack_public_path__ + "media/images/policies/step3-6875b3c56f9edf42f1ba1f5dc2c952a0.svg";